<template>
  <div id="app">
    <div>
      <b-dropdown
        v-model="projects"
        text="Select project"
        variant="primary"
        class="m-md-2"
      >
        <b-dropdown-item disabled value="0">Select project</b-dropdown-item>
        <b-dropdown-item
          v-for="project in projects"
          :key="project"
          :value="project"
          @click="
            selectedProject = project;
            deployOutput = '';
          "
        >
          {{ project }}
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <div>
        <!-- :disabled="deployOutput != ''" -->
      <b-button
        v-if="selectedProject"
        variant="danger"
        @click="deploy()"
        >Deploy {{ selectedProject }}</b-button
      >
    </div>

    <div v-if="waiting">
      <div class="m-5">
        <b-overlay :show="waiting" rounded="sm"> </b-overlay>
      </div>
    </div>

    <div v-if="deployOutput" class="container">
        <pre><code class="terminal">{{ deployOutput }}</code></pre>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "App",
  data: function () {
    return {
      selectedProject: null,
      deployOutput: "",
      waiting: false,
      projects: [
        "project-554sohard",
        "project-6s",
        "project-asian-picasso",
        "project-first-vis-aid",
        "project-getgradea",
        "project-hotshot-crew-554",
        "project-ilikepy",
        "project-infoviz",
        "project-love554",
        "project-newgroup",
        "project-ninjav",
        "project-pajamas",
        "project-quaranteam",
        "project-rotten-potatoes",
        "project-survivors",
        "project-tbd000",
        "project-the-vizards",
        "project-uncharted",
        "project-visual-dance",
        "project-viz-a-vis",
        "project-wpm",
      ],
    };
  },
  methods: {
    deploy: function () {
      this.waiting = true;
      this.deployOutput = '';
      //console.log(process.env.VUE_APP_DEPLOY_SERVICE_URL + "deploy");
      axios
        .post(process.env.VUE_APP_DEPLOY_SERVICE_URL + "deploy", {
          project: this.selectedProject,
        })
        .then((response) => {
          this.deployOutput = response.data;
          this.waiting = false;
        });
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.container {
  background-color: black;
  margin: 10px;
  padding: 10px;
  text-align: left;
}

.terminal {
  background-color: black;
  color: cyan;
  text-align: left;
  width: 50%;
}

pre {
  color: cyan !important;
}
</style>
